// convert date string to format: 1 January 2021
// parse the date string to be compatible with all browsers.
// Firefox doesn't support the date string format returned from the API
export function dateFormat(date: string): string {
  const inputDate = new Date(date);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false // use 24-hour format
  };

  return inputDate.toLocaleDateString('en-AU', options);
}
